<template>

<div>

  <div v-if="flight">

    <h1>Flight: {{ flight.flight_number }}</h1>

    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="updateFlight">

        <FlightFields :airlines="airlines"/>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled><span>Updating...</span></button>
          </div>
          <div v-else>
            <button type="submit" class="button" v-if="userRole == 1"><span>Update flight</span></button>
          </div>
        </div>

      </form>

    </div>

  </div>

</div>

</template>

<script>
import FlightFields from '@/components/FlightFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'FlightEdit',
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data () {
    return {
      flight: null,
      errors: null,
      airlines:[]
    }
  },
  components: {
    FlightFields,
    Errors
  },
  created () {
    this.getAirlines()
    this.getFlight()
  },
  watch: {
    '$route': 'getFlight'
  },
  methods: {
    getFlight () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'flights/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.flight = response.data[0]
      })
    },
    getAirlines () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'airlines/', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.airlines = response.data
      })
    },
    updateFlight () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'flights/' + this.$route.params.id, {
        method: 'POST',
        body: JSON.stringify(this.flight),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}
</script>
